import { isNumberLike } from "@/utils/common";
import { multiply, fmoney } from "@/utils/count";
export default {
  filters: {
    // 将小数转成百分比
    percentage(val) {
      if (isNumberLike(val)) {
        const newVal = multiply(val, 100);
        return `${Number(newVal)}%`;
      } else {
        return "";
      }
    },
    // 金额千分位
    thousandth(val) {
      if (val || val == 0) {
        let valNub = parseFloat(val);
        return fmoney(valNub, 2);
      } else {
        return "";
      }
    },
  },
};
